<template>
    <div>


    <div id="renderContainer" style="z-index:0;top:0;position:absolute;width:100%;height:100%;">
        <v-expand-transition>
        <canvas style="width:100%;height:100%;" v-show="show"  id="renderCanvasPlay"></canvas>
        </v-expand-transition>

    </div>
        <v-expand-transition>

            <v-toolbar   v-show="show" style="cursor:pointer;z-index: 1;position:relative;background: transparent;" flat light >
                <v-spacer></v-spacer>
                <v-sheet

                        color="grey lighten-3"
                >
                <v-spacer></v-spacer>
                <v-toolbar-items>

                    <v-list-item>
                        <v-progress-linear
                                :value="float*100"
                                :color="rank_color"
                                height="25"
                                background-color="black"
                                dark

                        >
                            <template >
                                <span >{{ float.toFixed(2)}}</span>
                            </template>
                        </v-progress-linear>
                    </v-list-item>
                    <v-list-item>

                        <v-list-item-content v-if="show">
                            <v-list-item-title  class="headline">{{card_data.NAME}}</v-list-item-title>
                            <v-list-item-subtitle>flexas av <b>{{card_data.USER_NAME}}</b></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>

                        <v-btn style=""  small class="mx-auto" :class="rank_color">
                            {{rank_text}}
                        </v-btn>
                    </v-list-item>

                </v-toolbar-items>

                <v-spacer></v-spacer>



                </v-sheet>
                <v-spacer></v-spacer>

            </v-toolbar>



        </v-expand-transition>



    <canvas style="display:none;visibility:hidden;" id="normalMapper" height="890" width="640"></canvas>
    </div>
</template>

<script>
    import {Howl} from 'howler';

    import * as Three from 'three'
    import {CollectionCard3D} from "../helpers/CollectionCard3D"
    export default {
        name: "PlayCollection",
        props:{
            "card_data":Object,
            "show":Boolean
        },
        data(){
            return{
                loading:true,
                camera: null,
                scene: null,
                renderer: null,
                mesh: null,
                card:null,
                camToSave:{},
                model:1,
                collection:"",
                byRank:-1,
                byModel:-1,
                mobileShow:false,
                renderCanvasPlay:null,
                renderContainer:null,
                showMore:true,
                finishTime:null


            }
        },
        methods: {

            init: function() {
                this.renderCanvasPlay= document.getElementById('renderCanvasPlay');
                this.renderContainer= document.getElementById('renderContainer');

                this.camera = new Three.PerspectiveCamera(75, this.renderContainer.clientWidth/this.renderContainer.clientHeight, 0.1, 1000);
                this.camera.position.z = 10;


                this.scene = new Three.Scene();

                let light1 = new Three.PointLight( "white", 0.75 );
                let light2 = new Three.PointLight( "white", 0.75 );
                let light3 = new Three.AmbientLight( "white", 0.2 );
                light1.position.set( 0, 5, 50 );
                light2.position.set(0, 5, -50 );

                this.scene.add(light1);
                this.scene.add(light2);
                this.scene.add(light3);

                this.renderer = new Three.WebGLRenderer({canvas:this.renderCanvasPlay,antialias:true,alpha:true,preserveDrawingBuffer: true });
                this.renderer.sortObjects = false;

                this.renderer.setSize(this.renderContainer.clientWidth, this.renderContainer.clientHeight);

                this.camera.position.z=10;
                this.camera.position.z=10;
                this.camToSave.position = this.camera.position.clone();
                this.camToSave.rotation = this.camera.rotation.clone();

                //container.appendChild(this.renderer.domElement);
                this.updateCard();
                this.loading=false;




            },
            finish:function(){
               this.$emit("hide");
            },

            onResize:function(){
                //let container=document.getElementById('container0');
                console.log("RESIZE");
                if(this.show){
                    this.camera.aspect = document.getElementById("renderContainer").clientWidth / document.getElementById("renderContainer").clientHeight;
                    this.camera.updateProjectionMatrix();

                    document.getElementById("renderCanvasPlay").width=document.getElementById("renderContainer").clientWidth;
                    document.getElementById("renderCanvasPlay").height=document.getElementById("renderContainer").clientHeight;


                    this.renderer.setSize( document.getElementById("renderContainer").clientWidth , document.getElementById("renderContainer").clientHeight );
                }

            },
            animate: function() {
                requestAnimationFrame(this.animate);
                this.renderer.render(this.scene, this.camera);
            },
            updateCard:function(){
                clearTimeout(this.finishTime);
                let cc=new CollectionCard3D(this.card_data,this.$store).render();
                let removeMe = this.scene.getObjectByName("card");
                if(removeMe!==null){
                    this.scene.remove(removeMe);
                }
                cc.name="card";
                this.restoreCamera(this.camToSave.position, this.camToSave.rotation, this.camToSave.controlCenter);

                this.scene.add(cc);
                this.updateAnimation(cc);
                if(this.card_data.TYPE!=="TEST"){
                    this.get_card_uq();
                }
                else{
                    this.collection="Test"
                }
                let self=this;
                this.finishTime=setTimeout(function(){
                    self.finish();
                },15000);
                var sound = new Howl({
                    src: [`/api/sounds/card_alert${this.card_data.RANK_VALUE}.mp3`]
                });

                sound.play();



            },
            get_card_uq:function(){
                this.collection="";
                this.byRank=-1;
                this.byModel=-1;
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/get_card_uq?CID='+this.card_data.CID;

                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        console.log("err")

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        if(http.responseText==="no data"){
                            return {"COLLECTION_NAME":"Okänd","BYMODEL":0,"BYRANK":0}
                        }
                        else{
                            let data = JSON.parse(http.response);
                            self.byModel=data[0].BYMODEL;
                            self.byRank=data[0].BYRANK;
                            self.collection=data[0].COLLECTION_NAME



                        }

                    }


                };
                http.send();
            },
            restoreCamera(position, rotation){
                this.camera.position.set(position.x, position.y, position.z);
                this.camera.rotation.set(rotation.x, rotation.y, rotation.z);

            },
            updateAnimation(card3d){
                let counter=0;
                let self=this;
                return setInterval( function() {
                    self.animation_controller(card3d,counter);
                    counter+=1;
                }, (1000 / 30));
            },
            animation_controller(card3d,counter){
                let pi_fraction=Math.PI*(counter/75);
                card3d.rotation.y=pi_fraction+(Math.sin(pi_fraction-(Math.PI)));
                //this.animate();
                //cardContainer.renderer.render(cardContainer.scene,cardContainer.camera);
            }





        },
        mounted() {
            if(this.card_data!==null && this.show){
                let self=this;

                setTimeout(function(){

                    self.init();
                    self.animate();
                    window.addEventListener('resize', self.onResize)
                },500);
            }
        },
        watch:{
            card_data:function(){
                if(this.card_data!==null && this.show){

                    if(this.scene===null){
                        let self=this;

                        setTimeout(function(){
                            self.init();
                            self.animate();
                            window.addEventListener('resize', self.onResize)
                        },500);


                    }
                    else{
                        let self=this;
                        setTimeout(function(){
                            self.onResize();

                        },500);

                        this.updateCard();

                    }
                }
                else{
                    console.log(this.card_data)
                }
            }
        },
        computed:{

            rank_color:function(){
                if(!this.show){
                    return ""
                }
                else if(this.card_data.RANK_VALUE===0){
                    return "green"
                }
                else if(this.card_data.RANK_VALUE===1){
                    return "blue"
                }
                else if(this.card_data.RANK_VALUE===2){
                    return "purple"
                }
                else if(this.card_data.RANK_VALUE===3){
                    return "orange"
                }
                else{
                    return "black"
                }
            },
            rank_text:function(){
                if(!this.show){
                    return ""
                }
                else if(this.card_data.RANK_VALUE===0){
                    return "Vanlig"
                }
                else if(this.card_data.RANK_VALUE===1){
                    return "Ovanlig"
                }
                else if(this.card_data.RANK_VALUE===2){
                    return "Epic"
                }
                else if(this.card_data.RANK_VALUE===3){
                    return "Legendary"
                }
                else{
                    return "Okänd"
                }
            },
            float:function(){
                if(this.show){
                    return (Math.sqrt((this.card_data.FLOAT_X*this.card_data.FLOAT_X)+(this.card_data.FLOAT_Y*this.card_data.FLOAT_Y))/Math.sqrt(2));
                }
                else{
                    return 1
                }
            }
        }
    }
</script>

<style>
    ::-webkit-scrollbar {
        width: 0 !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent !important;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent !important;
    }
</style>
